import {
  APP_INITIALIZER,
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { TranslocoRootModule } from './app/transloco-root.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideAnimations } from '@angular/platform-browser/animations';
import { withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, Routes } from '@angular/router';
import {
  interceptorProviders,
  FormComponent,
  SpinnerComponent,
  SpinnerService
} from '@jump-tech-frontend/relay/shared';
import { AppVersion, AppName, GlobalErrorHandler, EnvironmentToken } from '@jump-tech-frontend/app-config';
import * as appVersion from './app-version.json';
import WebFont from 'webfontloader';
import { defineCustomElements } from '@jump-tech-frontend/core-components/loader';
import { readOnlyServiceToken } from '@jump-tech-frontend/angular-common';
import { DatadogLoggerService } from './app/datadog-logger.service';

defineCustomElements();

const versionFile = appVersion;
const appRoutes: Routes = [{ path: '**', component: FormComponent }];

if (environment.production) {
  enableProdMode();
}

WebFont.load({
  google: { families: ['Material Icons', 'Material Icons Outline'] }
});

const initialiserFactory = (_: DatadogLoggerService) => () => {
  // no op
};

bootstrapApplication(SpinnerComponent, { providers: [provideZoneChangeDetection()] }).catch(console.error);
bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(BrowserModule, NgbModule, NgxSpinnerModule, TranslocoRootModule),
    { provide: AppVersion, useValue: versionFile.appVersion },
    { provide: AppName, useValue: 'RELAY' },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: EnvironmentToken, useValue: environment },
    {
      provide: readOnlyServiceToken,
      useValue: { isReadOnly: () => false }
    },
    provideAppInitializer(() => {
      const intializerFn = initialiserFactory(inject(DatadogLoggerService));
      return intializerFn();
    }),
    ...interceptorProviders,
    provideRouter(appRoutes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    SpinnerService
  ]
}).catch(console.error);
